<template>
  <div id="fullContents">
        <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
        <div id="suningAgree">
            <div>
            <p style="font-size:16pt; line-height:150%; margin:0pt; orphans:0; text-align:center; widows:0">
                <span style="font-family:彩虹小标宋; font-size:16pt">企业征信授权书</span>
            </p>
            <p style="line-height:24pt; margin:0pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:14pt">&#xa0;</span>
            </p>
            <p style="line-height:24pt; margin:0pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:14pt">江苏苏宁银行股份有限公司：</span>
            </p>
            <p style="line-height:24pt; margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:14pt">现同意贵行在办理涉及到本单位业务时可以根据</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt">国家有关规定向</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">金融信用信息基础数据库</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">及其他依法成立的征信机构</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">查询本单位的信用信息，并同意</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">贵行按照国家有关规定</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">向</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">其</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">报送本单位的相关信用信息</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt">。业务种类包括：</span>
            </p>
            <p style="line-height:24pt; margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:14pt">一、审核本单位授信</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt">业务</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt">申请；</span>
            </p>
            <p style="line-height:24pt; margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:14pt">二、审核本单位作为担保人的业务；</span>
            </p>
            <p style="line-height:24pt; margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:14pt">三、对已发放的信贷业务进行贷后管理、贷款重组等；</span>
            </p>
            <p style="line-height:24pt; margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:14pt">四、处理本单位信用信息异议；</span>
            </p>
            <p style="line-height:24pt; margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:14pt">五、需要查询或报送信用信息的其他业务。</span>
            </p>
            <p style="line-height:24pt; margin:0pt; text-indent:28.5pt">
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">若本单位在贵行业务未获批准办理，本授权书、企业信用报告等资料无须退回本单位。</span>
            </p>
            <p style="line-height:24pt; margin:0pt; text-indent:28.5pt">
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">本授权书自本单位有权操作人在</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">相关页面</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">点击或勾选“确认授权”并进行电子签名确认后生效，本授权书有效期至本单位业务结清</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">/办结</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">之日止</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">，包含授信额度有效期以及授信额度有效期内支用的每笔借款结清前的任意时点</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">，</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">其中，循环额度不以本单位是否有借据余额作为前提条件</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">；或者</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">本单位</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">在被授权人处办理的业务被转让、被授权人作为管理服务人时，被授权人仍有权查询、报送本</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">单位</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">的后续信息</span>
                <span style="font-family:彩虹粗仿宋; font-size:14pt; font-weight:bold">。在授权期限内未经贵行书面同意本授权书不可撤销。</span>
            </p>
            <p style="line-height:24pt; margin:0pt; text-indent:28.5pt">
                <span style="font-family:彩虹粗仿宋; font-size:14pt">&#xa0;</span>
            </p>
            <p style="line-height:24pt; margin:0pt; text-indent:28.5pt">
                <span style="font-family:彩虹粗仿宋; font-size:14pt">单位名称：</span>
            </p>
            <p style="line-height:24pt; margin:0pt; orphans:0; text-align:justify; text-indent:29.25pt; widows:0">
                <span style="font-family:彩虹粗仿宋; font-size:14pt">统一社会信用代码：</span>
            </p>
            <p style="line-height:24pt; margin:0pt; text-indent:28.5pt">
                <span style="font-family:彩虹粗仿宋; font-size:14pt">签署日期：   年   月   日</span>
            </p>
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt">&#xa0;</span>
            </p>
            <p style="margin:0pt; orphans:0; text-align:justify; widows:0">
                <span style="font-family:'Times New Roman'; font-size:10.5pt">&#xa0;</span>
            </p>
        </div>
        </div>
  </div>
</template>
<script>
export default {
  components: {  },
  name: 'suningEnterpriseCreditauthorize',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  mounted() {
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
/* common css */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: '微软雅黑';
}
p {
  /* margin-bottom: 8px; */
}
#fullContents {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
#fullContents .crossBox{
  text-align: right;
}
#fullContents .cross{
  font-size: 20px;
}
#suningAgree {
  overflow: scroll;
  line-height: 20px;
  text-align: left;
  -webkit-overflow-scrolling: touch;
}
#suningAgree .title {
    font-size: 15px;
    text-align: center;
}
#suningAgree .bold {
    font-weight: bold;
}
#suningAgree .center {
    text-align: center;
}
#suningAgree .right {
    text-align: right;
}
#suningAgree .underline {
    text-decoration: underline;
}
#suningAgree .write-line {
    overflow: hidden; 
    width: 90%; ;
    margin: 0 auto;
}
</style>
